import e from "@dialpad/dialtone-tokens/layered/themes/tokens-aurora-colors.css?inline";
//#region themes/aurora.js
var t = {
	brand: {
		css: e,
		name: "aurora"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
